import { Button, HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { actions } from 'store/app.slice';

const I18nButton = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = i18n.language || 'en';

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ja' : 'en';
    i18n.changeLanguage(newLanguage);
    dispatch(actions.setLanguage(newLanguage));
  };

  return (
    <Button
      onClick={toggleLanguage}
      size="sm"
      variant="outline"
      colorScheme="blue"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 1000,
        fontFamily: 'var(--body-font)'
      }}
    >
      <HStack spacing={2}>
        <Text>{currentLanguage === 'en' ? '🇯🇵' : '🇺🇸'}</Text>
        <Text>{currentLanguage === 'en' ? '日本語' : 'English'}</Text>
      </HStack>
    </Button>
  );
};

export default I18nButton;

